import React, { Component } from 'react'
import ReactDOM, { render, createPortal } from 'react-dom'
import BookNowForm from './bookNowForm';

const loadedStates = ['complete', 'loaded', 'interactive'];

class BookNowProperty extends Component {
  render() {
  	let not_found_section;
    let book_now_section = document.getElementById("book-now-form");
    if (book_now_section) {
      not_found_section = createPortal(<BookNowForm />, book_now_section)
    }
    return  (
      <div>
        {not_found_section}
        <BookNowForm />
        <button className="btn-book-now hidden">Book now</button>
      </div>
    );
  }
}

export default BookNowProperty;
function executeReactComponent () {
ReactDOM.render(
  <BookNowProperty/>,
  document.getElementById('book_now_property')
);
}

if (loadedStates.includes(document.readyState) && document.body) {
  executeReactComponent();
} else {
  window.addEventListener('DOMContentLoaded', executeReactComponent, false);
}
